import { useState } from "react";
import ScrollReveal from "@/components/feature/ScrollReveal";

const ahisFeedbackFormUrl =
  "https://docs.google.com/forms/d/e/1FAIpQLSeETVSBPO16xyK_48EwDz-Vg-1hlD0_K9pXKRDEjbAkJNN6lA/viewform?usp=publish-editor";

const faqs = [
  {
    question: "What industries does Presuni serve?",
    answer:
      "We primarily serve enterprise clients across healthcare, finance, government, and technology sectors. Our healthcare expertise led us to build AHIS.",
  },
  {
    question: "Is AHIS available for international hospitals?",
    answer:
      "Yes. AHIS is designed for African healthcare systems but can be deployed globally. We handle localisation, compliance, and infrastructure setup.",
  },
  {
    question: "How does Presuni approach cybersecurity?",
    answer:
      "We follow ISO 27001 and NIST frameworks. Our engagements include audits, pen testing, threat monitoring, and incident response planning.",
  },
  {
    question: "What is the typical project timeline?",
    answer:
      "Most consulting engagements run 4-12 weeks. Software projects typically span 8-24 weeks depending on scope and complexity.",
  },
  {
    question: "Do you offer ongoing support?",
    answer:
      "Absolutely. We offer managed support, security monitoring, and continuous engineering retainer packages for all clients. Early AHIS users can submit product feedback at: " +
      ahisFeedbackFormUrl,
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full py-16 md:py-24 bg-gray-50 dark:bg-dark-card">
      <div className="px-4 md:px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-brand-50 dark:bg-brand-500/10 text-brand-600 dark:text-brand-400 text-xs font-semibold uppercase tracking-wider mb-4">
              FAQ
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 dark:text-white mb-3">
              Common Questions
            </h2>
            <p className="text-sm md:text-base text-gray-500 dark:text-gray-400 max-w-xl mx-auto">
              Quick answers about working with Presuni.
            </p>
          </div>
        </ScrollReveal>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <ScrollReveal key={i} delay={(i % 3) + 1}>
              <div className="rounded-xl bg-white dark:bg-dark-bg border border-gray-100 dark:border-dark-border overflow-hidden">
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                  aria-expanded={openIndex === i}
                >
                  <span className="text-sm md:text-base font-semibold text-gray-900 dark:text-white pr-4">
                    {faq.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-lg text-gray-400 transition-transform duration-300 flex-shrink-0 ${
                      openIndex === i ? "rotate-180" : ""
                    }`}
                  />
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === i ? "max-h-48" : "max-h-0"
                  }`}
                >
                  <p className="px-5 pb-5 text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}